import styled from 'styled-components/macro';

import CardBase from '@components/common/core/Surfaces/Card';
import TextBase from '@components/common/core/DataDisplay/Text';

export const RedirectButton = styled.button`
  background-color: unset;
  padding: unset;
  border: unset;
  font-size: 0.875rem;
  font-family: ${({ theme }) => theme.fonts.body};
  color: ${({ theme }) => theme.colors.green.default};
  transition: all 0.3s;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
`;

export const Text = styled(TextBase)`
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.gray[2]};
  text-align: center;
  line-height: 120%;
`;

export const Content = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  & > svg {
    min-width: 40px;
  }
`;

export const CardWrapper = styled(CardBase)`
  padding: 20px 18px;
  box-sizing: border-box;
  min-width: 264px;
  height: 96px;
  background-color: ${({ theme }) => theme.colors.gray[6]};
  border-radius: 12px;
  border: unset;
  cursor: default;
  width: 100%;
  display: flex;
  align-items: center;
`;
